<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import AiWorkspacePage from '@/components/AiWorkspace/AiWorkspacePage.vue'

// The meta carries the page's layout and its keyboard shortcut declaration.
definePage({
  meta: { ...PageMeta.AiWorkspace.Chat.Meta, pageTitle: PageMeta.AiWorkspace.Chat.Title },
})
</script>

<template>
  <AiWorkspacePage />
</template>
